import httpClient from '/src/utils/httpClient';

export function updateHTMLCodeApiCall({ userId, sectionId, content }) {
  return httpClient.put(`api/html-blocks/${blockId}`, {
    profileId: userId,
    id: sectionId,
    content,
  });
}
